import { useCallback } from 'react';
import {
  isCurrentMeetInstanceUrl,
  openExternalMeetingLink,
  parseSangomaMeetingUrl,
} from '../utils/meetingLinkRouting';
import { useLaunchMeeting } from './useLaunchMeeting';

/**
 * SM-1165: route a meeting-link click. URLs on the Meet instance we are running
 * from reuse `useLaunchMeeting` — the same hosted popup, existing-window focus,
 * popup-blocked fallback, and standalone in-page navigation as every other
 * in-app meeting launch. Every other URL (Zoom, Teams, legacy hosts, another
 * Meet deployment per SM-1282, or a malformed/room-less link) opens in a new tab
 * instead of navigating the TeamHub host.
 */
export const useOpenMeetingLink = (): ((url: string) => void) => {
  const launchMeeting = useLaunchMeeting();

  return useCallback(
    (url: string) => {
      const parsed = isCurrentMeetInstanceUrl(url) ? parseSangomaMeetingUrl(url) : null;
      if (parsed) {
        launchMeeting(parsed.meetingId, parsed.password);
        return;
      }
      openExternalMeetingLink(url);
    },
    [launchMeeting],
  );
};
